import React,{useState} from 'react';
//import Loading from "./Loading";
//import Inc from './Include';
import Guide from './Guide';
import Sorry from './Sorry';
import './Top.scss';

function Top ({ajax,setUid,close}){
	const [isGuide,setIsGuide] = useState(false);
	const [isSorry,setIsSorry] = useState(false);

	let configclass = "config";
	if( process.env.REACT_APP_RUNMODE!=="DEV" ){
		configclass += " hide";
	}
	const config = ()=>{
		ajax("config",{},()=>{
			console.log("config");
		});
	}
	const change = ()=>{
		ajax("uid/new",{},(res)=>{
      setUid(res.uid);
			console.log("change");
		});
	}
	const openGuide = ()=>{
		setIsGuide(true);
	}
	const closeGuide = ()=>{
		setIsGuide(false);
	}
	const closeSorry = ()=>{
		setIsSorry(false);
	}
	const check = ()=>{
		ajax("play/check",{},(res)=>{
			if( res.ok ){
				close();
			} else {
				setIsSorry(true);
			}
		});
	};


	return (
		<div id="top">
			<div className={configclass}>
				<button
					onClick={config}
				>初期設定</button>
				<button
					onClick={change}
				>UID変更</button>
			</div>

			<div className="ver">ver.190531</div>
			<div className="plate">
				<div className="mark">
					<i className="fas fa-fish"></i>
				</div>
				<div className="title">
					<h1>Farrow</h1>
					<p>ひとりになると死んじゃう冒険</p>
				</div>
				<div className="menu">
					<button
							onClick={check}
					>始める</button>
					<button
						className="second"
						onClick={openGuide}
					><i className="fas fa-book fa-fw"></i> 遊び方</button><br/>
				</div>
				<div className="credit">
					<a href="https://goisagi.retro-ink.com/" rel="noopener noreferrer"><i className="fas fa-copyright"></i>レトロインク 2019</a>
				</div>
			</div>

			<Guide close={closeGuide} isOpen={isGuide}/>
			<Sorry close={closeSorry} isOpen={isSorry}/>
		</div>
    );
}

export default Top;
